import ReactSelectFormatter from '../../services/ReactSelectFormatter';

export default class CompanyInformationSelector {
    static fillSelects(array, type) {
        if (array.length > 0) {
            return ReactSelectFormatter.formatDAWA(array, type);
        } else {
            return [];
        }
    }

    static filterMunicipalitiesByRegion(municipalities, regionId) {
        if (this.canFilterMunicipalities(municipalities, regionId)) {
            return municipalities.filter((item) => {
                return item.regionskode === regionId
            });
        } else {
            return municipalities;
        }
    }

    static canFilterMunicipalities(municipalities, regionId) {
        return regionId !== '' && municipalities.length > 0
    }
}


// WEBPACK FOOTER //
// ./web/src/reducers/company/CompanyInformationSelector.js